import api from "./api";

const endpoints = "/Job/GetAllJobs";


export const getAllJobs = async () => {
  try {
    const response = await api.get(endpoints);  
    return response.data;
  } catch (error) {
    console.error("Error fetching all jobs:", error);
    throw error;
  }
};